import React, { useEffect, useState } from 'react'

// Components
import Autocomplete from '../Autocomplete'
import { InvoicePaymentMethodsSelect } from '../../../models/EnumEntity'

const AutocompletePaymentMethods = ({ setFilters, filters, ...props }) => {
  const [paymentMethodsSelected, setPaymentMethodsSelected] = useState([])

  useEffect(() => {
    if (filters?.paymentMethods) {
      const paymentMethods = Array.isArray(filters.paymentMethods)
        ? filters.paymentMethods
        : [filters.paymentMethods]

      const selectedOptions = InvoicePaymentMethodsSelect.filter(option =>
        paymentMethods.find(pm => pm === option.value)
      )

      setPaymentMethodsSelected(selectedOptions)
    } else {
      setPaymentMethodsSelected([])
    }
  }, [filters?.paymentMethods])

  const handlePaymentAutocompleteChange = (event, options) => {
    setPaymentMethodsSelected(options)
    setFilters({
      ...filters,
      pageNumber: 1,
      paymentMethods: options.map(s => s.value)
    })
  }

  return (
    <Autocomplete
      fullWidth
      multiple
      value={paymentMethodsSelected}
      size='small'
      name='paymentMethod'
      loadingText='Buscando medios de pago...'
      getOptionLabel={(option) => option.label}
      label='Medios de pago'
      {...props}
      options={InvoicePaymentMethodsSelect}
      data-testid='order-states-autocomplete'
      onChange={handlePaymentAutocompleteChange}
    />
  )
}

export default AutocompletePaymentMethods
